import "./Connect.module.css";
import Navigation from "@/reusable_sections/Header";
import DirectInquiry from "./sections/DirectInquiry";
import TheNetwork from "./sections/TheNetwork";
import StoreFooter from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Navigation />
      <DirectInquiry />
      <TheNetwork />
      <StoreFooter />
    </div>;
}